/** @jsxImportSource @emotion/react */

import styled from '@emotion/styled';

import { ModuleComponents } from '../../components/ModuleComponents';
import { Wrapped } from '../../hocs/withRenderSettings';
import { media } from '../../services/media';
import { Storyblok, StoryblokSection } from '../../storyblok';

export const Module = ({
    sectionData,
}: StoryblokSection<Storyblok.Component.Module>) => {
    const { components, renderSettings, component, renderEffect } = sectionData;

    return (
        <Wrapped
            renderAs={Section}
            renderSettings={renderSettings}
            data-module={component}
        >
            <ModuleComponents components={components} />
        </Wrapped>
    );
};

const Section = styled.section`
    ${media.max('lg')} {
        padding: 40px 0;
    }

    ${media.min('lg')} {
        padding: 80px 0;
    }
`;

const LoaderWrapper = styled.div`
    background-color: white;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    display: flex;
    align-items: center;
    justify-content: center;
`;
